import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=f1cf3056&scoped=true"
import script from "./flight.vue?vue&type=script&lang=js"
export * from "./flight.vue?vue&type=script&lang=js"
import style0 from "./flight.vue?vue&type=style&index=0&id=f1cf3056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf3056",
  null
  
)

export default component.exports